"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusTag = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const SunshineIcon_1 = __importDefault(require("../_core/SunshineIcon"));
const Text_1 = __importDefault(require("../_core/Text"));
const StatusTag = ({ backgroundColor, iconName, text, textColor, }) => {
    return (react_2.default.createElement(react_1.Flex, { alignItems: "center", bgColor: backgroundColor, borderRadius: "radius-full", gap: "space-4", height: 22, paddingX: "space-8" },
        react_2.default.createElement(SunshineIcon_1.default, { color: textColor, name: iconName, size: "icon-14" }),
        react_2.default.createElement(Text_1.default, { color: textColor, fontWeight: "weight-500" }, text)));
};
exports.StatusTag = StatusTag;
